import React, { useState } from 'react'
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import Carouselpic1 from '../../Assets/foodimage_3-transformed.jpeg'
import Carouselpic2 from '../../Assets/foodimage_1-wmremoved.jpeg'
import Carouselpic3 from '../../Assets/foodimage4.jpeg'
import Packages from '../Packages/index'
import axios from 'axios';
import fssaiLogo from '../../Assets/fssai-logo.webp'
import { FaWhatsapp } from 'react-icons/fa'
const LandingPage = () => {
    const theme = useTheme()
    const isMobileScreen = useMediaQuery(theme.breakpoints.down('sm'))
    const [data, setData] = useState({
        FullName: '',
        Address: '',
        ContactDetails: '',
        Description: '',
        Email: '',
        packageName: '',
        packageType: ''
    })
    const [message, setMessage] = useState(false)
    const [loading, setLoading] = useState(false)
    // const [clipBoard, setClipBoard] = useState(false)
    // fghgfhsf
    const [clipBoard, setClipBoard] = useState(false);

    const phoneNumber = "+919360944349"; // Replace with your phone number

    const handleWhatsAppClick = () => {
        const whatsappURL = `https://wa.me/${phoneNumber}?text=Hello%20I%20want%20to%20place%20an%20order`;

        window.open(whatsappURL, '_blank');
    };

    // fghsgdhsgas
    var EmailData = {
        service_id: 'service_1qm5fqq',
        template_id: 'template_gbe89s4',
        user_id: '4qEsIkilwwuHG-7q-',
        template_params: {
            'from_name': data.FullName,
            "Name": data.FullName,
            "Email": data.Email,
            "Address": data.Address,
            "PhoneNumber": data.ContactDetails,
            "Description": data.Description + "  " + data.packageName + "  " + data.packageType
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)
        axios.post('https://api.emailjs.com/api/v1.0/email/send', JSON.stringify(EmailData), {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(() => {
            setLoading(false)
            setMessage(true)
            setTimeout(() => {
                window.location.reload()
            }, 1000)
        }).catch((err) => {
            alert(err)
        })
    }

    const Year = new Date().getFullYear()
    return (
        <div className='overflow-hidden'>
            <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel" >
                <div className="carousel-indicators">
                    <Box component={'button'} type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></Box>
                    <Box component={'button'} type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></Box>
                    <Box component={'button'} type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></Box>
                </div>
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        {isMobileScreen ?
                            <>
                                <img src={Carouselpic2} className="d-block w-100 bg-position" style={{ height: '200px' }} alt="..." />
                                <div className="carousel-caption carouseltext px-3">
                                    <h6 className='text-capitalize fw-bold pt-1'>Your favorite meals are <br />just a click away!</h6>
                                </div>
                            </>
                            :
                            <>
                                <img src={Carouselpic2} className="d-block w-100 bg-position" style={{ height: '400px' }} alt="..." />
                                <div className="carousel-caption carouseltext px-4">
                                    <h1 className='text-capitalize fw-bold' style={{ letterSpacing: '1px', paddingTop: '110px' }}>Your favorite meals are <br />just a click away</h1>
                                    <p>When you’re hungry, we’ll be your best friend.</p>
                                </div>
                            </>
                        }
                    </div>
                    <div className="carousel-item ">
                        {isMobileScreen ?
                            <>
                                <img src={Carouselpic1} className="d-block w-100 bg-position" style={{ height: '200px' }} alt="..." />
                                <div className="carousel-caption carouseltext px-3">
                                    <h6 className='text-capitalize fw-bold'>Hungry? <br />Let us feed you…fast!</h6>
                                </div>
                            </>
                            :
                            <>
                                <img src={Carouselpic1} className="d-block w-100 bg-position" style={{ height: '400px' }} alt="..." />
                                <div className="carousel-caption carouseltext px-4">
                                    <h1 className='text-capitalize fw-bold' style={{ letterSpacing: '1px', paddingTop: '110px' }}>Hungry? <br />Let us feed you…fast!</h1>
                                    <p>When you’re hungry, we’ll be your best friend.</p>
                                </div>
                            </>
                        }
                    </div>
                    <div className="carousel-item">
                        {isMobileScreen ?
                            <>
                                <img src={Carouselpic3} className="d-block w-100 bg-position" style={{ height: '200px' }} alt="..." />
                                <div className="carousel-caption carouseltext px-3">
                                    <h6 className='text-capitalize fw-bold pt-1'>We’ll be at your front door <br />in just a few minutes!</h6>
                                </div>
                            </>
                            :
                            <>
                                <img src={Carouselpic3} className="d-block w-100 bg-position" style={{ height: '400px' }} alt="..." />
                                <div className="carousel-caption carouseltext px-4">
                                    <h1 className='text-capitalize fw-bold' style={{ letterSpacing: '1px', paddingTop: '110px' }}>We’ll be at your front door <br />in just a few minutes!</h1>
                                    <p>When you’re hungry, we’ll be your best friend.</p>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </div>
            {isMobileScreen ? (
                <div className='d-flex justify-content-center scrolling-text'>
                    <div className='d-flex align-items-center delivery'>
                        <main className='mx-2'>Free delivery upto 5km</main>
                        <img src={require('../../Assets/delivery_image.png')} alt='delivery_Image' width={'50px'} height={'50px'} />
                    </div>
                </div>
            ) : (
                <></>
            )}
            <div className='container'>
                <div className='about-container' style={{ paddingTop: isMobileScreen ? '0px' : '38px' }}>
                    <Box component={'div'} className='border-0 about-card' borderRadius={isMobileScreen ? '15px' : '15px'}>
                        <div className='shadow-sm rounded-4  px-4 pb-4'>
                            <Grid container spacing={4}>
                                {isMobileScreen ? <img src={require('../../Assets/dish one.webp')} width={'100%'} height={'150px'} alt='dishimg' style={{ marginLeft: '30px', borderRadius: '10px' }} />
                                    : <Grid item md={4} lg={4}>
                                        <Box component={'img'} src={require('../../Assets/dish one.webp')} alt='about-us img' borderRadius={isMobileScreen ? '15px' : '15px 0px 0px 15px'} width={'100%'} height={'400px'} />
                                    </Grid>}
                                <Grid item sm={12} md={8} lg={8}>
                                    <Box component={'div'} marginTop={isMobileScreen ? '20px' : ''} className='about-content'>
                                        <h1 className='about-card-title'>About Us</h1>
                                        <Box component={'div'}>
                                            <p className='about-description'><q>Welcome to Mani's Kitchen</q>, where culinary expertise meets a nurturing touch. With a remarkable journey of three years in the organic foods realm, our founder has mastered the art of crafting delectable dishes like millet dosa, idli, and pongal. Fueled by a passion for wholesome ingredients and mindful cooking, her experience shines through in every bite.
                                                <br /><br />At Mani's Kitchen, we believe in more than just serving food, we serve care and nourishment. Just like a caring parent, our founder infuses each creation with love and attention, ensuring that every dish embodies the essence of homemade comfort. With a dedication akin to caring for a child, we prioritize quality, health, and authenticity in every aspect of our culinary journey.</p>
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>
                        </div>
                    </Box>
                </div>
            </div>
            <Packages />
            <div style={{ backgroundColor: '#7ed957' }} className='text-center mt-4 mx-4' id='contact-form'>
                <img src={require('../../Assets/contactusheader.png')} alt='package_img' height={'80px'} />
            </div>
            <div className='contactUs-container'>
                {isMobileScreen ?
                    <Grid container spacing={3}>
                        <Grid item md={5} xs={12} sm={12} >
                            <h2>Order Form</h2>
                            <div className={`glass-form ${isMobileScreen ? '' : 'mx-5'} w-100`}>
                                <form action="https://formsubmit.co/el/5444823e8119d8b19916ab7999c8cd78" method="POST" onSubmit={(e) => handleSubmit(e)} >
                                    <label className='fs-5'>FullName *</label>
                                    <input type='text' name='Name' required className='form-control' placeholder='your name' onChange={(e) => setData({ ...data, FullName: e.target.value })} />
                                    <label className='mt-1 fs-5'>Address *</label>
                                    <textarea name='Address' required rows='4' className='form-control glass-field' placeholder='Address in detail' onChange={(e) => setData({ ...data, Address: e.target.value })} />
                                    <label className='fs-5 mt-1'>PhoneNumber *</label>
                                    <div className="input-group mb-3">
                                        <span className="input-group-text" id="basic-addon1">+91</span>
                                        <input type="number" className="form-control" name='PhoneNumber' required placeholder="Phone Number" aria-label="Username" aria-describedby="basic-addon1" onChange={(e) => setData({ ...data, ContactDetails: e.target.value })} />
                                    </div>
                                    <label className='fs-5 mt-1'>Email *</label>
                                    <div className="input-group mb-3">
                                        <span className="input-group-text" id="basic-addon1">Email</span>
                                        <input type="email" className="form-control" name='Email' required placeholder="Email" aria-label="Username" aria-describedby="basic-addon1" onChange={(e) => setData({ ...data, Email: e.target.value })} />
                                    </div>
                                    <label className='mt-1 fs-5'>Package Type</label>
                                    <select className='form-select' onChange={(e) => { setData({ ...data, packageType: e.target.value }) }}>
                                        <option defaultChecked value={'Monthly'}>Monthly</option>
                                        <option value={'Weekly'}>Weekly</option>
                                    </select>
                                    <label className='mt-2 fs-5'>Package Name</label>
                                    <select className='form-select' onChange={(e) => { setData({ ...data, packageName: e.target.value }) }}>
                                        <option value={'Breakfast & dinner'}>Breakfast & dinner</option>
                                        <option value={'Breakfast & Lunch'}>Breakfast & Lunch</option>
                                        <option value={'Lunch & Dinner'}>Lunch & Dinner</option>
                                        <option defaultChecked value={'Breakfast & Lunch & Dinner'}>Breakfast & Lunch & Dinner</option>
                                        <option value={'Lunch'}>Lunch</option>
                                    </select>
                                    <label className='mt-2 fs-5'>Description</label>
                                    <textarea className='form-control mb-3 glass-field' name='Message' required type='text' rows='4' placeholder='description' onChange={(e) => setData({ ...data, Description: e.target.value })} />
                                    {loading ?
                                        <div className='text-center bg-white rounded-3'>
                                            <img src={require('../../Assets/mailGif.gif')} alt='loading_svg' width={'80px'} height={'60px'} />
                                        </div>
                                        :
                                        <input className={`border-0 rounded-3 w-100 py-2 ${message ? 'bg-success text-white' : 'text-dark'} `} type='submit' value={message ? "Submitted" : 'Submit'} />
                                    }
                                </form>
                            </div>
                        </Grid>
                        <Grid item md={6} xs={12} sm={12} >
                            <div>
                                <h2>Mani's Kitchen</h2>
                                <main className='mt-3'><b>Address:</b><br></br> Mani's Kitchen <br></br> kalpana Layout,<br></br> Ganapathy , coimbatore - 641006 </main>
                                <main className='mt-2'><b>Email: </b>mainskitchen.311@gmail.com</main>
                                <p className='mt-2'><b>Phone Number:</b> +91 93609 44349 <button className='border-0 text-decoration-none' onClick={() => { navigator.clipboard.writeText(9360944349); setClipBoard(true) }}>{clipBoard ? '🔗 Copied' : 'Copy'}</button> </p>
                                <p className='text-success cursor-pointer' onClick={handleWhatsAppClick} >WhatsApp Us  <FaWhatsapp size={'30px'} /></p>
                                <main><img src={fssaiLogo} alt='fssai_logo' width={'100px'} height={'100px'} /></main>
                            </div>
                            <div>
                                <h3>Disclaimer</h3>
                                <main><b>*</b>No preservatives and food Coloring are Added .</main>
                                <main>Foods are Made in hygiene environment and packed with all the safety Measures <b>*</b></main>
                            </div>
                            <iframe title='g-map' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3915.9407567965063!2d76.9680510746064!3d11.043068704219685!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba858643edddfb3%3A0xe4fa1f62fe253c4c!2sKalpana%20Layout%2C%20Ganapathy%2C%20Coimbatore%2C%20Tamil%20Nadu%20641006!5e0!3m2!1sen!2sin!4v1694497482337!5m2!1sen!2sin" width={isMobileScreen ? "100%" : "500"} height="300" className='border-0 ' style={{ marginTop: isMobileScreen ? '10px' : '40px' }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </Grid>
                    </Grid>
                    :
                    <Grid container spacing={3}>
                        <Grid item md={6} xs={12} sm={12}>
                            <div>
                                <h2>Mani's Kitchen</h2>
                                <main className='mt-3'><b>Address:</b><br></br> Mani's Kitchen <br></br> kalpana Layout,<br></br> Ganapathy , coimbatore - 641006 </main>
                                <main className='mt-2'><b>Email: </b>mainskitchen.311@gmail.com</main>
                                <p className='mt-2'><b>Phone Number:</b> +91 93609 44349 <button className='border-0 text-decoration-none' onClick={() => { navigator.clipboard.writeText(9360944349); setClipBoard(true) }}>{clipBoard ? '🔗 Copied' : 'Copy'}</button> </p>
                                <p className='text-success cursor-pointer' onClick={handleWhatsAppClick} >WhatsApp Us  <FaWhatsapp size={'30px'} /></p>
                                <main><img src={fssaiLogo} alt='fssai_logo' width={'100px'} height={'80px'} /></main>
                            </div>
                            <div className='mt-2'>
                                <h3>Disclaimer</h3>
                                <main><b>*</b>No preservatives and food Coloring are Added .</main>
                                <main>Foods are Made in hygiene environment and packed with all the safety Measures <b>*</b></main>
                            </div>
                            <iframe title='g-map' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3915.9407567965063!2d76.9680510746064!3d11.043068704219685!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba858643edddfb3%3A0xe4fa1f62fe253c4c!2sKalpana%20Layout%2C%20Ganapathy%2C%20Coimbatore%2C%20Tamil%20Nadu%20641006!5e0!3m2!1sen!2sin!4v1694497482337!5m2!1sen!2sin" width={isMobileScreen ? "100%" : "500"} height="300" className='border-0 ' style={{ marginTop: isMobileScreen ? '10px' : '40px' }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </Grid>
                        <Grid item md={5} xs={12} sm={12} >
                            <h2>Order Form</h2>
                            <div className={`glass-form ${isMobileScreen ? '' : 'mx-5'} w-100`}>
                                <form action="https://formsubmit.co/el/5444823e8119d8b19916ab7999c8cd78" method="POST" onSubmit={(e) => handleSubmit(e)} >
                                    <label className='fs-5'>FullName *</label>
                                    <input type='text' name='Name' required className='form-control' placeholder='your name' onChange={(e) => setData({ ...data, FullName: e.target.value })} />
                                    <label className='mt-1 fs-5'>Address *</label>
                                    <textarea name='Address' required rows='4' className='form-control glass-field' placeholder='Address in detail' onChange={(e) => setData({ ...data, Address: e.target.value })} />
                                    <label className='fs-5 mt-1'>PhoneNumber *</label>
                                    <div className="input-group mb-3">
                                        <span className="input-group-text" id="basic-addon1">+91</span>
                                        <input type="number" className="form-control" name='PhoneNumber' required placeholder="Phone Number" aria-label="Username" aria-describedby="basic-addon1" onChange={(e) => setData({ ...data, ContactDetails: e.target.value })} />
                                    </div>
                                    <label className='fs-5 mt-1'>Email *</label>
                                    <div className="input-group mb-3">
                                        <span className="input-group-text" id="basic-addon1">Email</span>
                                        <input type="email" className="form-control" name='Email' required placeholder="Email" aria-label="Username" aria-describedby="basic-addon1" onChange={(e) => setData({ ...data, Email: e.target.value })} />
                                    </div>
                                    <label className='mt-1 fs-5'>Package Type</label>
                                    <select className='form-select' onChange={(e) => { setData({ ...data, packageType: e.target.value }) }}>
                                        <option defaultChecked value={'Monthly'}>Monthly</option>
                                        <option value={'Weekly'}>Weekly</option>
                                    </select>
                                    <label className='mt-2 fs-5'>Package Name</label>
                                    <select className='form-select' onChange={(e) => { setData({ ...data, packageName: e.target.value }) }}>
                                        <option value={'Breakfast & dinner'}>Breakfast & dinner</option>
                                        <option value={'Breakfast & Lunch'}>Breakfast & Lunch</option>
                                        <option value={'Lunch & Dinner'}>Lunch & Dinner</option>
                                        <option defaultChecked value={'Breakfast & Lunch & Dinner'}>Breakfast & Lunch & Dinner</option>
                                        <option value={'Lunch'}>Lunch</option>
                                    </select>
                                    <label className='mt-2 fs-5'>Description</label>
                                    <textarea className='form-control mb-3 glass-field' name='Message' required type='text' rows='4' placeholder='description' onChange={(e) => setData({ ...data, Description: e.target.value })} />
                                    {loading ?
                                        <div className='text-center bg-white rounded-3'>
                                            <img src={require('../../Assets/mailGif.gif')} alt='loading_svg' width={'80px'} height={'60px'} />
                                        </div>
                                        :
                                        <input className={`border-0 rounded-3 w-100 py-2 ${message ? 'bg-success text-white' : 'text-dark'} `} type='submit' value={message ? "Submitted" : 'Submit'} />
                                    }
                                </form>
                            </div>
                        </Grid>
                    </Grid>
                }
            </div>
            <div className='text-center'>
                <main>{`All rights Reserved to Mainskitchen @ ${Year}`}</main>
            </div>
        </div>
    )
}

export default LandingPage